import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ngbAccordion',
  templateUrl: './app-ngbAccordion.component.html',
  styleUrls: ['./app-ngbAccordion.component.css']
})
export class AppNgbAccordionComponent {
  @Input() class = '';
  @Input() headerName = '';
  @Input() downArrowClass = 'fas fa-angle-double-down text-success mr-1';
  @Input() rightArrowClass = 'fas fa-angle-double-right text-success mr-1';
  @Input() isToggleOn = true;

  toggleArrowIconHandler() {
    this.isToggleOn = !this.isToggleOn;
  }
}
